import { render } from "./NumberButtons.vue?vue&type=template&id=452be61e&ts=true"
import script from "./NumberButtons.ts?vue&type=script&lang=ts"
export * from "./NumberButtons.ts?vue&type=script&lang=ts"

import "./NumberButtons.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__